const LOCAL_STORAGE_AUTH_KEY = 'WECHECK_TOKEN';

const getToken = () => window.localStorage.getItem(LOCAL_STORAGE_AUTH_KEY);

export { getToken, LOCAL_STORAGE_AUTH_KEY };
